// src/components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ user, children }) {
  if (!user) {
    console.warn("🚫 Accès refusé : utilisateur non connecté");
    return <Navigate to="/login" replace />;
  }

  return children;
}



